import { compact } from "lodash";

function createApiPath(
  path: string,
  version?: string,
) {
  const pathComponent = path.startsWith("/") ? path : `/${path}`;
  return `${compact(["/api", version]).join("/")}${pathComponent}`;
}

export default function withApi<T extends Record<string, any>>(
  { version, routes }: {
    version?: number,
    routes: T
  },
): T {
  const addApiPath = (obj: any): any => {
    if (typeof obj === "string") {
      return createApiPath(obj, version ? `v${version}` : undefined);
    }

    if (typeof obj === "object" && obj !== null) {
      return Object.entries(obj).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: addApiPath(value),
      }), {});
    }

    return obj;
  };

  return addApiPath(routes);
}
